// extracted by mini-css-extract-plugin
module.exports = {"code":"Code_code__1q0xX"};